import classNames from "classnames";

export function LiveGameSiege({ siege, leftSide }) {
    return (
        <div className={classNames("flex items-center justify-center", leftSide ? "flex-row" : "flex-row-reverse")}>
            {siege > 0 && (
                <>
                    <img className="w-6 h-6 mt-[10px]" src="/liveGameIcons/unit_stat_attack_siege.png" alt="" />
                    <p className="text-[#b1b1b1] text-xl">{siege}</p>
                    <p className="text-[#b1b1b1] text-xl -mt-1 hidden">+</p>
                </>
            )}
        </div>
    )
}